const axios = require('axios');

import CombinationForm from './components/CombinationForm.vue';

const combinationDetailApp = {
	components: { CombinationForm },
	data() {
		return {
			dataApileft: '',
			dataApiright: '',
			dataGuid: '',
			dataLanguage: '',
			dataItemLeft: '',
			dataItemRight: '',
			dataSelectlabel: '',
			dataConfirmlabel: '',

			newItemLeft: null,
			newItemRight: null,
			loading: false,
			itemsLeft: [],
			itemsRight: [],
			pristine: true,
			url: '',
		};
	},

	computed: {
		leftId() {
			return this.newItemLeft ? this.newItemLeft.id : '';
		},
		itemsSetLeft() {
			return this.itemsLeft.length;
		},
		itemsSetRight() {
			return this.itemsRight.length;
		},
		queryParamsLeft() {
			const urlParams = new URLSearchParams();
			urlParams.set('overviewPageId', this.dataGuid);
			//urlParams.set('culture', this.dataLanguage);
			return urlParams.toString();
		},
		queryParamsRight() {
			const urlParams = new URLSearchParams();
			urlParams.set('overviewPageId', this.dataGuid);
			//urlParams.set('culture', this.dataLanguage);
			urlParams.set('leftOptionNodeId', this.leftId);
			return urlParams.toString();
		},
	},
	methods: {
		async init() {
			this.loading = true;

			if (this.$el.dataset.apileft) this.dataApileft = this.$el.dataset.apileft;
			if (this.$el.dataset.apiright)
				this.dataApiright = this.$el.dataset.apiright;
			if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
			if (this.$el.dataset.language)
				this.dataLanguage = this.$el.dataset.language;
			if (this.$el.dataset.itemleft)
				this.dataItemleft = this.$el.dataset.itemleft;
			if (this.$el.dataset.itemright)
				this.dataItemright = this.$el.dataset.itemright;
			if (this.$el.dataset.selectlabel) this.dataSelectlabel = this.$el.dataset.selectlabel;
			if (this.$el.dataset.confirmlabel) this.dataConfirmlabel = this.$el.dataset.confirmlabel;

			const responseLeft = await this.fetchDataLeft();
			this.setDataLeft(responseLeft);
			if (!this.dataItemleft && this.itemsSetLeft)
				this.dataItemleft = this.itemsLeft[0].name;
			this.newItemLeft = this.itemsLeft.find(
				(item) => item.name === this.dataItemleft
			);

			const responseRight = await this.fetchDataRight();
			this.setDataRight(responseRight);
			if (!this.dataItemright && this.itemsSetRight)
				this.dataItemright = this.itemsRight[0].name;
			this.newItemRight = this.itemsRight.find(
				(item) => item.name === this.dataItemright
			);
			this.url = this.newItemRight.url;

			this.loading = false;
		},
		async fetchDataLeft() {
			try {
				const response = await axios.get(
					`${this.dataApileft}?${this.queryParamsLeft}`
				);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		async fetchDataRight() {
			try {
				const response = await axios.get(
					`${this.dataApiright}?${this.queryParamsRight}`
				);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		setDataLeft(response) {
			if (!response || response.status != 200) return;
			this.itemsLeft = response.data;
		},
		setDataRight(response) {
			if (!response || response.status != 200) return;
			this.itemsRight = response.data;
		},
		async setItemleft(item, ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.remove('is-active');
			}
			if (!item || !item.name || !item.id) return;

			this.newItemLeft = item;

			this.loading = true;

			const response = await this.fetchDataRight();
			this.setDataRight(response);

			this.newItemRight = null;
			this.url = '';

			this.loading = false;
		},
		setItemRight(item, ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.remove('is-active');
			}
			if (!item || !item.name || !item.url) return;

			this.newItemRight = item;

			this.url = this.newItemRight.url;
		},
		navigate() {
			if (this.url) window.location = this.url;
		},
	},
	mounted() {
		this.init();
	},
};

export default combinationDetailApp;
